import type { IconColor, IconSize, IconStrokeWidth } from './core.ts'

export const iconSizeClassMap: Record<IconSize, string> = {
  '5xs': 'icon-5xs',
  '4xs': 'icon-4xs',
  '3xs': 'icon-3xs',
  '2xs': 'icon-2xs',
  xs: 'icon-xs',
  sm: 'icon-sm',
  md: 'icon-md',
  lg: 'icon-lg',
  xl: 'icon-xl',
  '2xl': 'icon-2xl',
  '3xl': 'icon-3xl',
  '4xl': 'icon-4xl',
  '5xl': 'icon-5xl',
  '6xl': 'icon-6xl',
  '7xl': 'icon-7xl',
  '8xl': 'icon-8xl',
  '9xl': 'icon-9xl',
  '10xl': 'icon-10xl',
  '11xl': 'icon-11xl',
  '12xl': 'icon-12xl',
  full: 'icon-full',
}

export const iconStrokeWidthClassMap: Record<IconStrokeWidth, string> = {
  '0': 'stroke-0',
  '1': 'stroke-1',
  '1.5': 'stroke-[1.5]',
  '2': 'stroke-2',
}

export const iconGlowMap: Partial<Record<IconColor, string>> = {
  info: 'drop-shadow-glow-blue-light',
  positive: 'drop-shadow-glow-green-light',
  negative: 'drop-shadow-glow-red-light',
  caution: 'drop-shadow-glow-yellow-light',
  notice: 'drop-shadow-glow-purple-light',
}
